import { cn } from '@/utils/cn'

export type ApprovalTab = 'financial' | 'details'

interface ApprovalDetailTabsProps {
  activeTab: ApprovalTab
  onTabChange: (tab: ApprovalTab) => void
}

export function ApprovalDetailTabs({
  activeTab,
  onTabChange,
}: ApprovalDetailTabsProps) {
  const tabs: { id: ApprovalTab; label: string }[] = [
    { id: 'financial', label: 'Financial Summary' },
    { id: 'details', label: 'Plan Details' },
  ]

  return (
    <div className="inline-flex bg-accent border border-accent-border rounded-md p-1">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'px-4 py-1.5 text-sm font-medium rounded-sm transition-colors cursor-pointer',
            activeTab === tab.id
              ? 'bg-primary text-white'
              : 'text-primary-active hover:text-primary'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
